import { render } from "./TheAdminProfessionalUpdate.vue?vue&type=template&id=24c8c60e&ts=true"
import script from "./TheAdminProfessionalUpdate.vue?vue&type=script&lang=ts"
export * from "./TheAdminProfessionalUpdate.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__